import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { SERVICE_IMAGES } from "@/lib/images";
import Reveal from "@/components/Reveal";

const SERVICES = [
  { key: "reinigungsservice", img: SERVICE_IMAGES.reinigungsservice },
  { key: "serviceTeam", img: SERVICE_IMAGES.serviceTeam },
  { key: "security", img: SERVICE_IMAGES.security },
];

export default function ServicesPreview() {
  const { t } = useLanguage();
  return (
    <div className="grid md:grid-cols-3 gap-8">
      {SERVICES.map((s, i) => {
        const svc = t(`services.list.${s.key}`);
        return (
          <Reveal key={s.key} delay={i * 120}>
            <Link
              to={`/services#${s.key}`}
              data-testid={`service-preview-${s.key}`}
              className="group block bg-card border border-border hover:border-gold/60 transition-all duration-500"
            >
              <div className="zoom-parent aspect-[4/3] bg-champagne/30">
                <img src={s.img} alt={svc.name} loading="lazy" className="w-full h-full object-cover zoom-img" />
              </div>
              <div className="p-8">
                <h3 className="font-heading text-2xl mb-1 font-light">{svc.name}</h3>
                <p className="font-heading text-xl text-gold mb-3" data-testid={`service-preview-price-${s.key}`}>{svc.price}</p>
                <p className="text-sm text-ink-muted leading-relaxed mb-5 line-clamp-3">{svc.intro}</p>
                <span className="text-[11px] tracking-[0.25em] uppercase text-gold elegant-link group-hover:text-ink">
                  {t("common.more")}
                </span>
              </div>
            </Link>
          </Reveal>
        );
      })}
    </div>
  );
}
